import NextLink from "next/link";
import * as React from "react";
import { cn } from "@tillix/ui-atoms/lib/utils";
import { cva, type VariantProps } from "cva";

const linkVariants = cva({
  base: "text-blue-600 underline-offset-4 hover:text-blue-800 hover:underline",
  variants: {
    variant: {
      default: undefined,
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof linkVariants> {
  href: string;
  useNextLink?: boolean;
  variant?: VariantProps<typeof linkVariants>["variant"];
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, variant, useNextLink = true, ...props }, ref) => {
    const Comp = useNextLink ? NextLink : "a";
    return (
      <Comp
        className={cn(linkVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Link.displayName = "Link";

export { Link, linkVariants };
